import useAddRequestStore from 'store/addRequestStore';
import { classNames } from 'util/Funcs';

interface Props {
    isEditMode?: boolean;
}
export default function RequestOverviewTextArea({ isEditMode = false }: Props) {
    const { requestData, setRequestData, clearErrors, errors } = useAddRequestStore();
    return (
        <>
            <textarea
                id="description"
                rows={12}
                placeholder="The buyer is looking for a villa with a pool. It’s for the buyer, their partner and their 3 kids. Budget is flexible, they value privacy and like to host dinner parties outside with friends on summer nights."
                className={classNames(
                    isEditMode ? 'w-full' : 'w-full lg:w-1/2',
                    'px-3 py-2 bg-gray-50 border  rounded-md text-lg outline-none',
                    errors.description ? 'border-red-500' : 'border-gray-200',
                )}
                value={requestData.description || ''}
                onChange={(e) => {
                    setRequestData({ description: e.target.value });
                    clearErrors('description');
                }}
            />
            {errors.description && <p className="text-red-500 text-sm mt-1">{errors.description}</p>}
        </>
    );
}
